import { db } from '../config/firebase';
import { 
  collection, 
  addDoc, 
  serverTimestamp, 
  query, 
  where, 
  orderBy, 
  getDocs, 
  doc, 
  updateDoc, 
  writeBatch 
} from 'firebase/firestore';

// Function to create a new notification
export const createNotification = async (userId, type, action, message, relatedData = {}) => {
  try {
    const notification = {
      userId,
      type,        // 'invite', 'group', 'membership', 'admin'
      action,      // specific action like 'received', 'created', 'deleted', etc.
      read: false,
      createdAt: serverTimestamp(),
      message,
      ...relatedData
    };

    await addDoc(collection(db, 'notifications'), notification);
    console.log('Notification created:', notification);
  } catch (error) {
    console.error('Error creating notification:', error);
  }
};

// Function to get unread notifications for a user
export const getUnreadNotifications = async (userId) => {
  try {
    const notificationsQuery = query(
      collection(db, 'notifications'),
      where('userId', '==', userId),
      where('read', '==', false),
      orderBy('createdAt', 'desc')
    );

    const snapshot = await getDocs(notificationsQuery);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching unread notifications:', error);
    return [];
  }
};

// Function to mark a notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, {
      read: true
    });
  } catch (error) {
    console.error('Error marking notification as read:', error);
  }
};

// Function to mark all notifications as read for a user
export const markAllNotificationsAsRead = async (userId) => {
  try {
    const batch = writeBatch(db);
    const notificationsQuery = query(
      collection(db, 'notifications'),
      where('userId', '==', userId),
      where('read', '==', false)
    );

    const snapshot = await getDocs(notificationsQuery);
    
    snapshot.docs.forEach(doc => {
      batch.update(doc.ref, { read: true });
    });

    await batch.commit();
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
  }
};